import React, { useState, useEffect } from 'react';
import { getPracticeOverviewAiSummary } from 'api/group';
import { TPracticeAiSummaryVo } from '../../types';
import MarkdownRenderer from 'components/MarkdownRenderer';
import s from './s.module.less';

const AISummary: React.FC = () => {
    const [data, setData] = useState<TPracticeAiSummaryVo | null>(null);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        getPracticeOverviewAiSummary().then((res) => {
            if (!res.error) setData(res?.data?.data ?? null);
        });
    }, []);

    if (!data?.contentMd) return null;

    return (
        <div className={`${s.wrap} ${expanded ? s.expanded : ''}`}>
            <div className={s.bg1} />
            <div className={s.bg2} />
            <div className={s.header}>
                <div className={s.icon}>
                    <svg viewBox="0 0 20 20" fill="none" width="20" height="20">
                        <path d="M10 2l1.5 4.5L16 8l-4.5 1.5L10 14l-1.5-4.5L4 8l4.5-1.5L10 2z" fill="currentColor" />
                        <path d="M15 12l.75 2.25L18 15l-2.25.75L15 18l-.75-2.25L12 15l2.25-.75L15 12z" fill="currentColor" opacity=".6" />
                    </svg>
                </div>
                <span className={s.title}>AI Summary</span>
                {data.generatedAt && (
                    <span className={s.date}>
                        Updated {new Date(data.generatedAt).toLocaleDateString()}
                    </span>
                )}
            </div>
            <div className={s.card}>
                <h4 className={s.cardTitle}>Key Insights</h4>
                <MarkdownRenderer content={data.contentMd} size="small" />
                {expanded && (
                    <span className={s.toggleBtn} onClick={() => setExpanded(false)}>Show less</span>
                )}
            </div>
            {!expanded && (
                <div className={s.overlay}>
                    <span className={s.toggleBtn} onClick={() => setExpanded(true)}>Show more</span>
                </div>
            )}
        </div>
    );
};

export default AISummary;
